import React, { useState, useRef, useEffect } from 'react';
import Navbar from '../../Components/Navbar/Navbar';
import { Layout, Col, Row, Select, Input, Table, Button, message } from 'antd';
import { UseGetRequest } from '../../Utils/api/ApiRequests';
import { usePostRequest } from '../../hooks/usePostRequest';

const EditableCell = ({ editable, children, ...props }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(children[1]);
  const inputRef = useRef(null);

  const handleEdit = () => {
    if (editable) {
      setIsEditing(true);
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setIsEditing(false);

      const td = e.target.closest('td');
      let nextTd = td.nextSibling;

      while (nextTd && !nextTd.getAttribute('data-editable')) {
        nextTd = nextTd.nextSibling;
      }

      if (nextTd) {
        const input = nextTd.querySelector('input');
        if (input) {
          input.focus();
        } else {
          nextTd.click();
        }
      }
    }
  };

  useEffect(() => {
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  return (
    <td {...props} onClick={handleEdit} data-editable={editable}>
      {isEditing ? (
        <Input
          ref={inputRef}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          autoFocus
          onKeyDown={handleKeyDown}
        />
      ) : (
        value
      )}
    </td>
  );
};

const ScoreCard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [playerData, setPlayerData] = useState([]);
  // const [pageSize, setPageSize] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState('Player');
  const [playerScores, setPlayerScores] = useState({});
  const { Option } = Select;
  const postRequest = usePostRequest();

  const fetchPlayerData = async () => {
    setIsLoading(true);
    const response = await UseGetRequest('individualstroke_player/get', {
      individual_player: '',
      page: 1,
    });
    if (response?.data) {
      setPlayerData(response.data.data);
      // setPageSize(response.data.size);
    } else {
      setPlayerData([]);
    }
    setIsLoading(false);
  };

  const fetchPlayerScores = async (playerName) => {
    setIsLoading(true);
    const response = await UseGetRequest(`individualstroke_player/scores/${playerName}`);
    if (response?.data) {
      setPlayerScores(response.data.scores);
    } else {
      setPlayerScores({});
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchPlayerData();
  }, []);

  const handlePlayerSelect = async (playerName) => {
    setSelectedPlayer(playerName);
    await fetchPlayerScores(playerName);
  };

  const handleSaveScores = async () => {
    setIsLoading(true);
      const response = await postRequest('individualstroke_player/savescores', {
        playerName: selectedPlayer,
        scores: playerScores,
      });
      if (response?.data) {
        message.success(response.data.message);
      } else {
        message.error(response.error.message);
      }     
      setIsLoading(false);
    };

  const columns = [
    {
      title: ' ',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      onCell: () => ({
        editable: false,
      }),
    },
    ...Array.from({ length: 18 }, (_, index) => ({
      title: '',
      align: 'center',
      dataIndex: `score${index + 1}`,
      key: `score${index + 1}`,
      width: '10vw',
      onCell: (record) => ({
        editable: !record.isClickable,
      }),
    })),
  ];

  const dataHeader = [
    {
      key: '1',
      name: 'HOLES',
      score1: 1,
      score2: 2,
      score3: 3,
      score4: 4,
      score5: 5,
      score6: 6,
      score7: 7,
      score8: 8,
      score9: 9,
      score10: 10,
      score11: 11,
      score12: 12,
      score13: 13,
      score14: 14,
      score15: 15,
      score16: 16,
      score17: 17,
      score18: 18,
      hdc: '',
      isClickable: true,
    },
    {
      key: '2',
      name: 'PAR',
      score1: 4,
      score2: 3,
      score3: 4,
      score4: 4,
      score5: 4,
      score6: 3,
      score7: 5,
      score8: 3,
      score9: 5,
      score10: 5,
      score11: 4,
      score12: 4,
      score13: 3,
      score14: 4,
      score15: 3,
      score16: 5,
      score17: 4,
      score18: 5,
      hdc: '',
      isClickable: true,
    },
  ];

  const dataSource = [
    {
      key: '1',
      name: selectedPlayer,
      score1: playerScores.score1 || 0,
      score2: playerScores.score2 || 0,
      score3: playerScores.score3 || 0,
      score4: playerScores.score4 || 0,
      score5: playerScores.score5 || 0,
      score6: playerScores.score6 || 0,
      score7: playerScores.score7 || 0,
      score8: playerScores.score8 || 0,
      score9: playerScores.score9 || 0,
      score10: playerScores.score10 || 0,
      score11: playerScores.score11 || 0,
      score12: playerScores.score12 || 0,
      score13: playerScores.score13 || 0,
      score14: playerScores.score14 || 0,
      score15: playerScores.score15 || 0,
      score16: playerScores.score16 || 0,
      score17: playerScores.score17 || 0,
      score18: playerScores.score18 || 0,
      hdc: 0,
    },
  ];

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  const combinedDataSource = [...dataHeader, ...dataSource];

  return (
    <Layout className="page">
      <Navbar navKey="individual_strokeplay" />
      <Layout className="content-container overflow-y">
        <Row className="custom-padding responsive-tab-inline">
          <Col span={15} className="header-container">
            SCORE CARD
          </Col>
        </Row>
        <Row>
          <Col span={24} className="px-4">
            <Select
              style={{ width: '50%' }}
              size="large"
              placeholder="Select Player"
              onChange={(value) => handlePlayerSelect(value)}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {playerData.map((option) => (
                <Option key={option.id} value={option.team_name}>
                  {option.team_name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row className="page-content">
          <Table
            className="score-table"
            loading={isLoading}
            components={components}
            bordered
            dataSource={combinedDataSource}
            columns={columns}
            pagination={false}
            showHeader={false}
            rowClassName={(record, index) => (index < 3 ? 'reduce-padding' : record.isClickable ? 'name-table' : 'score-table')}
          />
        </Row>

        <Row>
          <Col span={18}></Col>
          <Col align="right" span={6} className="px-4">
            <Button className="edit-btn" onClick={handleSaveScores}>Save</Button>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

export default ScoreCard;
